/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApDataGetResponseApiFrom } from '../../models/ap-data-get-response-api-from';

export interface ApiV3ServiceApDataGetGet$Plain$Params {

/**
 * * Interface language
 */
  lang?: string;

/**
 * * design version ID
 */
  id?: string;
}

export function apiV3ServiceApDataGetGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV3ServiceApDataGetGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApDataGetResponseApiFrom>>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceApDataGetGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ApDataGetResponseApiFrom>>;
    })
  );
}

apiV3ServiceApDataGetGet$Plain.PATH = '/api/v3/service/ApDataGet';
